import * as Sentry from '@sentry/browser';

export const logError = (error, info) => {
  Sentry.withScope(scope => {
    if (info) {
      Object.keys(info).forEach(key => {
        scope.setExtra(key, info[key]);
      });
    }
    Sentry.captureException(error);
  });
};
